// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"942c65e4","338":"942c65e4","375":"942c65e4","719":"942c65e4","779":"4ddc8ecd"}[chunkId] + ".chunk.css";
};